import React, { createContext, useCallback, useContext, useState } from 'react';
import GuestActionToast from '../components/GuestActionToast';

/**
 * GuestNudge — global toast manager so ANY component can call
 * `nudgeForSignin({ message, returnTo })` to surface a one-shot
 * "Sign in to save this" toast.
 *
 * Use:
 *   const { nudgeForSignin } = useGuestNudge();
 *   if (!userData) nudgeForSignin({ message: 'Sign in to save this college.' });
 */
const GuestNudgeContext = createContext({ nudgeForSignin: () => {} });

export function GuestNudgeProvider({ children }) {
    const [state, setState] = useState({ show: false, message: '', returnTo: null });

    const nudgeForSignin = useCallback(({ message, returnTo } = {}) => {
        setState({
            show: true,
            message: message || 'Sign in to save your activity.',
            returnTo: returnTo || (typeof window !== 'undefined' ? window.location.pathname + window.location.search : null),
        });
    }, []);

    const close = useCallback(() => setState((s) => ({ ...s, show: false })), []);

    return (
        <GuestNudgeContext.Provider value={{ nudgeForSignin }}>
            {children}
            <GuestActionToast
                show={state.show}
                message={state.message}
                returnTo={state.returnTo}
                onClose={close}
            />
        </GuestNudgeContext.Provider>
    );
}

export function useGuestNudge() {
    return useContext(GuestNudgeContext);
}
